import { numberToHumanChart } from '../../utils/formatter';

export default (options = {}) => ({
  chart: {
    type: 'column',
    ...(options.chartOptions || {}),
  },
  title: {
    text: null,
  },
  xAxis: {
    crosshair: true,
    ...(options.xAxisOptions ? options.xAxisOptions : {}),
  },
  tooltip: {
    padding: 8,
    pointFormatter() {
      return `
        <tr>
          <td class="text-left pl-0 text-nowrap">
            <span class="v-a-m mr-xxxs" style="color:${
              this.color || this.series.color
            };">\u25CF</span>
            <span class="v-a-m d-inline-block text-truncate" style="max-width: 170px;">${
              this.series.name
            }</span>
          </td>
          <td class="text-right pr-0">
            <strong>${options.tooltipValue ? options.tooltipValue(this.y) : this.y}</strong>
          </td>
        </tr>
      `;
    },
    ...(options.tooltipOptions ? options.tooltipOptions : {}),
  },
  legend: { enabled: false },
  yAxis: {
    min: 0,
    title: {
      text: null,
    },
    labels: {
      formatter() {
        if (options.labelValue) return options.labelValue(this.value);
        let value;
        if (this.value < 1) {
          value = this.value;
        } else {
          value = numberToHumanChart(this.value, options.abbreviationSettings);
        }
        return `${value}`;
      },
      ...(options.yAxisLabels ? options.yAxisLabels : {}),
    },
    ...(options.yAxisOptions ? options.yAxisOptions : {}),
  },
  lang: {
    noData: '<h2 class="text-lg m-b">No data to display</h2>',
  },
  plotOptions: {
    column: {
      borderRadius: 3,
      dataLabels: {
        enabled: true,
        formatter() {
          return options.labelFormatter ? options.labelFormatter(this.y) : undefined;
        },
        ...(options.plotOptionsLabels ? options.plotOptionsLabels : {}),
      },
      ...(options.plotOptionsColumn ? options.plotOptionsColumn : {}),
    },
    series: {
      ...(options.plotOptionsSeries ? options.plotOptionsSeries : {}),
    },
    ...(options.plotOptions ? options.plotOptions : {}),
  },
  ...options,
});
